import * as ContextMenuPrimitive from '@radix-ui/react-context-menu'
import { styled } from '../../../lib/stitches'

const Content = styled(ContextMenuPrimitive.Content, {
  zIndex: '100',
  position: 'fixed',
  borderRadius: '6px',
  backgroundColor: 'var(--gray-8)',
  color: 'var(--gray-1)',
  padding: '8px 0px',
  fontSize: '12px',
  overflow: 'hidden',
  minWidth: '125px',
  boxShadow: '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)'
})

const SubContent = styled(ContextMenuPrimitive.SubContent, {
  zIndex: '100',
  position: 'fixed',
  borderRadius: '6px',
  backgroundColor: 'var(--gray-8)',
  color: 'var(--gray-1)',
  padding: '8px 0px',
  fontSize: '12px',
  overflow: 'hidden',
  minWidth: '125px',
  boxShadow: '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)'
})

const Item = styled(ContextMenuPrimitive.Item, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  lineHeight: '32px',
  minHeight: '32px',
  padding: '0px 15px',
  position: 'relative',
  '&:hover': {
    textDecoration: 'underline !important',
    border: 'none',
    outline: 'none'
  }
})

const SubTrigger = styled(ContextMenuPrimitive.SubTrigger, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  lineHeight: '32px',
  minHeight: '32px',
  padding: '0px 15px',
  position: 'relative',
  '&:hover': {
    textDecoration: 'underline !important',
    border: 'none',
    outline: 'none'
  }
})

const CheckboxItem = styled(ContextMenuPrimitive.CheckboxItem, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  lineHeight: '32px',
  minHeight: '32px',
  padding: '0px 15px',
  position: 'relative',
  '&:hover': {
    textDecoration: 'underline !important',
    border: 'none',
    outline: 'none'
  }
})

const RightSlot = styled('div', {
  marginLeft: 'auto',
  paddingLeft: 20
})

const Root = ContextMenuPrimitive.Root
Root.defaultProps = {
  dir: 'ltr'
}

const ContextMenu = {
  ...ContextMenuPrimitive,
  Root,
  Content,
  SubContent,
  Item,
  CheckboxItem,
  SubTrigger,
  RightSlot
}

export default ContextMenu
